export function convertBooleanValuesToStringInJsonObject(obj: Object): any {
  return JSON.parse(
    JSON.stringify(obj, (key, value) => {
      return typeof value === 'boolean' ? `${value}` : value;
    })
  );
}
